"use client";

import { useState } from 'react';

export default function FMCGDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'CEO / CFO FMCG DASHBOARD',
      subtitle: 'Executive Revenue & Portfolio Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">FMCG Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Inventory Turnover', value: '8.4×', color: '#C5A572' },
            { x: 186, label: 'Market Share', value: '18.6%', color: '#16a34a' },
            { x: 356, label: 'Gross Margin', value: '42.8%', color: '#16a34a' },
            { x: 526, label: 'Promo ROI', value: '3.2×', color: '#C5A572' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
            </g>
          ))}

          {/* Revenue Growth by Category */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Revenue Growth by Category (₹ Cr)</text>
          <polyline points="40,285 80,272 120,268 160,255 200,250 240,240 280,235 320,225" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" />
          <polyline points="40,285 80,272 120,268 160,255 200,250 240,240 280,235 320,225 320,295 40,295 Z" fill="#1B2845" opacity="0.05" />
          {[40,80,120,160,200,240,280,320]?.map((x, i) => (
            <circle key={i} cx={x} cy={[285,272,268,255,250,240,235,225]?.[i]} r="3" fill="#C5A572" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug']?.map((m, i) => (
            <text key={i} x={40 + i * 40 - 6} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}

          {/* Gross Margin by SKU (Top 5) */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Gross Margin by SKU (Top 5)</text>
          {[
            { sku: 'SKU-A Premium', margin: '58%', color: '#16a34a' },
            { sku: 'SKU-B Standard', margin: '44%', color: '#65a30d' },
            { sku: 'SKU-C Economy', margin: '38%', color: '#C5A572' },
            { sku: 'SKU-D Value', margin: '32%', color: '#ca8a04' },
            { sku: 'SKU-E Budget', margin: '24%', color: '#ea580c' },
          ]?.map((s, i) => (
            <g key={i}>
              <text x="370" y={168 + i * 26} fill="#374151" fontSize="9" fontFamily="sans-serif">{s?.sku}</text>
              <rect x="480" y={156 + i * 26} width="160" height="14" fill="#f3f4f6" rx="3" />
              <rect x="480" y={156 + i * 26} width={parseFloat(s?.margin) * 2.4} height="14" fill={s?.color} rx="3" opacity="0.75" />
              <text x="648" y={168 + i * 26} fill={s?.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{s?.margin}</text>
            </g>
          ))}

          {/* Market Share Trend */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Market Share by Region</text>
          {[
            { region: 'North', share: '22.4%', color: '#16a34a' },
            { region: 'South', share: '18.6%', color: '#65a30d' },
            { region: 'East', share: '15.2%', color: '#C5A572' },
            { region: 'West', share: '20.8%', color: '#16a34a' },
          ]?.map((r, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{r?.region}</text>
              <rect x={28 + i * 168} y="364" width="140" height="12" fill="#f3f4f6" rx="3" />
              <rect x={28 + i * 168} y="364" width={parseFloat(r?.share) * 5.5} height="12" fill={r?.color} rx="3" opacity="0.8" />
              <text x={28 + i * 168} y="392" fill={r?.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{r?.share} share</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'SALES & DISTRIBUTION DASHBOARD',
      subtitle: 'Distributor Performance & Channel Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Sales & Distribution Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Sales Rep Productivity', value: '87%', color: '#C5A572' },
            { x: 186, label: 'Retail Coverage', value: '94.2%', color: '#16a34a' },
            { x: 356, label: 'Active Distributors', value: '284', color: '#1B2845' },
            { x: 526, label: 'Beat Compliance', value: '91%', color: '#16a34a' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
            </g>
          ))}

          {/* Distributor Performance Leaderboard */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Distributor Performance</text>
          {[
            { dist: 'Dist. North-01', score: 94, sales: '₹4.2Cr', color: '#16a34a' },
            { dist: 'Dist. South-03', score: 88, sales: '₹3.8Cr', color: '#65a30d' },
            { dist: 'Dist. East-02', score: 76, sales: '₹3.1Cr', color: '#C5A572' },
            { dist: 'Dist. West-04', score: 68, sales: '₹2.8Cr', color: '#ca8a04' },
            { dist: 'Dist. Central-01', score: 54, sales: '₹2.2Cr', color: '#ea580c' },
          ]?.map((d, i) => (
            <g key={i}>
              <text x="28" y={168 + i * 26} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{d?.dist}</text>
              <text x="200" y={168 + i * 26} fill="#6b7280" fontSize="8" fontFamily="sans-serif">{d?.sales}</text>
              <rect x="260" y={156 + i * 26} width="60" height="12" fill="#f3f4f6" rx="3" />
              <rect x="260" y={156 + i * 26} width={d?.score * 0.6} height="12" fill={d?.color} rx="3" opacity="0.75" />
              <text x="326" y={168 + i * 26} fill={d?.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{d?.score}</text>
            </g>
          ))}

          {/* Channel Performance Donut */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Channel Performance Mix</text>
          <circle cx="480" cy="220" r="52" fill="none" stroke="#f3f4f6" strokeWidth="22" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#1B2845" strokeWidth="22" strokeDasharray="163 327" strokeDashoffset="0" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#C5A572" strokeWidth="22" strokeDasharray="98 327" strokeDashoffset="-163" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#3b82f6" strokeWidth="22" strokeDasharray="49 327" strokeDashoffset="-261" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#8b5cf6" strokeWidth="22" strokeDasharray="17 327" strokeDashoffset="-310" />
          <text x="480" y="216" textAnchor="middle" fill="#1B2845" fontSize="12" fontWeight="bold" fontFamily="sans-serif">₹14.1Cr</text>
          <text x="480" y="230" textAnchor="middle" fill="#6b7280" fontSize="8" fontFamily="sans-serif">Total Sales</text>
          <rect x="370" y="285" width="8" height="8" fill="#1B2845" rx="1" />
          <text x="382" y="293" fill="#374151" fontSize="7" fontFamily="sans-serif">GT (50%)</text>
          <rect x="420" y="285" width="8" height="8" fill="#C5A572" rx="1" />
          <text x="432" y="293" fill="#374151" fontSize="7" fontFamily="sans-serif">MT (30%)</text>
          <rect x="470" y="285" width="8" height="8" fill="#3b82f6" rx="1" />
          <text x="482" y="293" fill="#374151" fontSize="7" fontFamily="sans-serif">eComm (15%)</text>
          <rect x="540" y="285" width="8" height="8" fill="#8b5cf6" rx="1" />
          <text x="552" y="293" fill="#374151" fontSize="7" fontFamily="sans-serif">Inst (5%)</text>

          {/* SKU Sales Trends */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">SKU Sales Trend by Region (Top 4)</text>
          {[
            { sku: 'SKU-A', north: 82, south: 68, east: 74, west: 90 },
            { sku: 'SKU-B', north: 64, south: 78, east: 58, west: 72 },
            { sku: 'SKU-C', north: 48, south: 52, east: 62, west: 44 },
            { sku: 'SKU-D', north: 36, south: 42, east: 38, west: 50 },
          ]?.map((s, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{s?.sku}</text>
              <text x={28 + i * 168} y="370" fill="#6b7280" fontSize="7" fontFamily="sans-serif">N:{s?.north} S:{s?.south} E:{s?.east} W:{s?.west}</text>
              <rect x={28 + i * 168} y="376" width="140" height="10" fill="#f3f4f6" rx="3" />
              <rect x={28 + i * 168} y="376" width={s?.north * 1.4} height="10" fill="#1B2845" rx="3" opacity="0.6" />
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'SUPPLY CHAIN & INVENTORY DASHBOARD',
      subtitle: 'Inventory Intelligence & Supply Chain Analytics',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Supply Chain & Inventory Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Distribution Efficiency', value: '91%', color: '#16a34a' },
            { x: 186, label: 'Stockout Alerts', value: '8 SKUs', color: '#dc2626' },
            { x: 356, label: 'Inventory Accuracy', value: '97.2%', color: '#16a34a' },
            { x: 526, label: 'Fill Rate', value: '96.8%', color: '#C5A572' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
            </g>
          ))}

          {/* Warehouse Inventory Level Progress Bars */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Warehouse Inventory by Category</text>
          {[
            { cat: 'Personal Care', level: 78, color: '#16a34a' },
            { cat: 'Food & Beverage', level: 62, color: '#65a30d' },
            { cat: 'Home Care', level: 45, color: '#ca8a04' },
            { cat: 'Baby Products', level: 88, color: '#16a34a' },
            { cat: 'Health & Wellness', level: 34, color: '#ea580c' },
          ]?.map((c, i) => (
            <g key={i}>
              <text x="28" y={168 + i * 26} fill="#374151" fontSize="9" fontFamily="sans-serif">{c?.cat}</text>
              <rect x="160" y={156 + i * 26} width="150" height="14" fill="#f3f4f6" rx="4" />
              <rect x="160" y={156 + i * 26} width={c?.level * 1.5} height="14" fill={c?.color} rx="4" opacity="0.75" />
              <text x="316" y={168 + i * 26} fill={c?.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{c?.level}%</text>
            </g>
          ))}

          {/* Demand Forecast vs Supply Plan */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Forecast vs Supply Plan</text>
          <polyline points="380,285 410,272 440,268 470,255 500,250 530,240 560,235 590,225 620,218 650,210" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" />
          <polyline points="380,290 410,278 440,275 470,262 500,258 530,248 560,244 590,235 620,228 650,220" fill="none" stroke="#C5A572" strokeWidth="2" strokeDasharray="5 3" strokeLinecap="round" />
          {['Jan','Mar','May','Jul','Sep','Nov']?.map((m, i) => (
            <text key={i} x={380 + i * 54 - 6} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}
          <rect x="370" y="315" width="10" height="4" fill="#1B2845" rx="1" />
          <text x="384" y="319" fill="#374151" fontSize="8" fontFamily="sans-serif">Demand Forecast</text>
          <rect x="470" y="315" width="10" height="4" fill="#C5A572" rx="1" />
          <text x="484" y="319" fill="#374151" fontSize="8" fontFamily="sans-serif">Supply Plan</text>

          {/* Inventory Aging Analysis */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Inventory Aging Analysis</text>
          {[
            { bucket: '0–30 days', pct: 58, color: '#16a34a' },
            { bucket: '31–60 days', pct: 24, color: '#65a30d' },
            { bucket: '61–90 days', pct: 12, color: '#ca8a04' },
            { bucket: '90+ days', pct: 6, color: '#dc2626' },
          ]?.map((a, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{a?.bucket}</text>
              <rect x={28 + i * 168} y="364" width="140" height="12" fill="#f3f4f6" rx="3" />
              <rect x={28 + i * 168} y="364" width={a?.pct * 1.4} height="12" fill={a?.color} rx="3" opacity="0.8" />
              <text x={28 + i * 168} y="392" fill={a?.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{a?.pct}% of stock</text>
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">FMCG Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">Purpose-built dashboards for every level of your FMCG organization.</p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards?.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/50'
              }`}
            >
              {d?.title?.split(' ')?.slice(0, 3)?.join(' ')}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-6">
            <h3 className="font-serif text-navy text-2xl font-bold mb-1">{dashboards?.[activeTab]?.title}</h3>
            <p className="text-charcoal/60 text-sm">{dashboards?.[activeTab]?.subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards?.[activeTab]?.svg}
          </div>
          <div className="flex gap-4 mt-6">
            <button className="px-6 py-2.5 bg-navy text-white text-sm font-semibold rounded-lg hover:bg-navy/90 transition-colors">View Demo</button>
            <button className="px-6 py-2.5 border border-gold text-gold text-sm font-semibold rounded-lg hover:bg-gold/5 transition-colors">Request Customization</button>
          </div>
        </div>
      </div>
    </section>
  );
}
